module.exports = __webpack_public_path__ + "static/media/language-top.14c4c43c.svg";